/* global axios */

import ApiClient from './ApiClient';

class PauseTemplates extends ApiClient {
  constructor() {
    super('', { accountScoped: true });
  }

  list() {
    return axios.get(`${this.baseUrl()}/pause_templates`);
  }

  create(payload) {
    return axios.post(`${this.baseUrl()}/pause_templates`, {
      pause_template: payload,
    });
  }

  update(id, payload) {
    return axios.patch(`${this.baseUrl()}/pause_templates/${id}`, {
      pause_template: payload,
    });
  }

  delete(id) {
    return axios.delete(`${this.baseUrl()}/pause_templates/${id}`);
  }
}

export default new PauseTemplates();
